import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ShieldCheck, Building2, LogIn, ArrowRight, Phone, CheckCircle2 } from "lucide-react";

export default function Landing() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#F9FAFB] flex flex-col">
      <header className="border-b border-border bg-white">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div>
            <div className="text-[10px] overline">ANV Associate</div>
            <div className="text-xl font-bold tracking-tight text-[#064E3B]">AccountifyPro</div>
          </div>
          <div className="flex items-center gap-2">
            <Link to="/pricing" data-testid="header-pricing">
              <Button variant="ghost">Pricing</Button>
            </Link>
            <Link to="/firm/signup" data-testid="header-signup">
              <Button variant="outline">Register Firm</Button>
            </Link>
            <Link to="/firm/login" data-testid="header-login">
              <Button className="btn-primary">Firm Login</Button>
            </Link>
          </div>
        </div>
      </header>

      <main className="flex-1">
        <section className="max-w-7xl mx-auto px-6 py-16 grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="overline mb-3">A GST-ready accounting suite</div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900 leading-none">
              Books that add up.
              <br />
              <span className="text-[#064E3B]">Every rupee, every day.</span>
            </h1>
            <p className="mt-6 text-slate-600 max-w-xl">
              Dual portals for Owner and Accountant, GST-ready invoices with CGST/SGST auto-split,
              POS with barcode scan, delivery challan with vehicle KM reports, WhatsApp reminders,
              GSTR-1 / 3B, Balance Sheet, P&amp;L and 20+ reports — all in one place.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Button className="btn-primary" onClick={() => navigate("/firm/signup")} data-testid="hero-cta-signup">
                Create your firm <ArrowRight size={16} className="ml-1" />
              </Button>
              <Button variant="outline" onClick={() => navigate("/firm/login")} data-testid="hero-cta-login">
                <LogIn size={16} className="mr-1" /> Firm Login
              </Button>
              <Button variant="ghost" onClick={() => navigate("/super-admin")} data-testid="hero-cta-super-admin">
                <ShieldCheck size={16} className="mr-1" /> Super Admin
              </Button>
              <Button variant="link" onClick={() => navigate("/pricing")} data-testid="hero-cta-pricing" className="text-[#064E3B]">
                View pricing →
              </Button>
            </div>
            <ul className="mt-8 grid grid-cols-2 gap-3 text-sm text-slate-700">
              {["GSTR-1 & GSTR-3B", "Delivery Challan + vehicle KM", "POS barcode + UPI QR", "10-day WhatsApp reminders",
                "P&L bill / item-wise", "Balance Sheet & Trial Balance", "Loan EMI schedule", "Excel import / export"].map(
                (t) => (
                  <li key={t} className="flex items-center gap-2"><CheckCircle2 size={14} className="text-[#166534]" /> {t}</li>
                ))}
            </ul>
          </div>
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1542744173-05336fcc7ad4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBhY2NvdW50YW50JTIwd29ya2luZyUyMGRhc2hib2FyZHxlbnwwfHx8fDE3ODQxMzQ4Njd8MA&ixlib=rb-4.1.0&q=85"
              className="rounded-lg border border-border shadow-xl w-full object-cover aspect-[4/3]"
              alt="Accountant"
            />
            <div className="absolute -bottom-4 -left-4 bg-white border border-border rounded-lg p-4 shadow-lg">
              <div className="overline">Total Sales · This Month</div>
              <div className="text-3xl font-mono font-bold text-[#064E3B]">₹ 12,84,530</div>
              <div className="text-xs text-slate-500 mt-1">▲ 18% vs last month</div>
            </div>
          </div>
        </section>
      </main>

      <footer className="border-t border-border bg-white py-4">
        <div className="max-w-7xl mx-auto px-6 flex flex-wrap items-center justify-between text-xs text-muted-foreground">
          <div>© {new Date().getFullYear()} AccountifyPro • Developed by <span className="font-semibold text-slate-700">ANV ASSOCIATE</span></div>
          <div className="flex items-center gap-1"><Phone size={12} /> 8446463026</div>
        </div>
      </footer>
    </div>
  );
}
